/**
 * Базовый адрес API. В браузере — пусто: API на том же origin (`/api/...`, Caddy).
 * На сервере Next.js — внутренний адрес, например `http://api:3000` (задаётся в рантайме).
 */
let baseUrl = '';
export function configureApiClient(options) {
    baseUrl = options.baseUrl.replace(/\/$/, '');
}
/** Ошибка API: тело — ProblemDetails (RFC 9457, ADR-032). */
export class ApiError extends Error {
    status;
    problem;
    constructor(status, problem) {
        super(problem.detail ?? problem.title);
        this.status = status;
        this.problem = problem;
        this.name = 'ApiError';
    }
}
/** Mutator для orval: fetch с базовым адресом и разбором ошибок problem+json. */
export async function apiFetch(url, options = {}) {
    const response = await fetch(`${baseUrl}${url}`, {
        ...options,
        headers: { accept: 'application/json', ...options.headers },
    });
    const text = await response.text();
    const body = text ? JSON.parse(text) : undefined;
    if (!response.ok && !isAcceptedErrorPayload(response.status, body)) {
        throw new ApiError(response.status, toProblem(response, body));
    }
    return body;
}
/** 503 от readiness — штатный ответ со схемой HealthReady, а не ошибка. */
function isAcceptedErrorPayload(status, body) {
    return status === 503 && typeof body === 'object' && body !== null && 'checks' in body;
}
function toProblem(response, body) {
    if (typeof body === 'object' && body !== null && 'status' in body && 'title' in body) {
        return body;
    }
    return { type: 'about:blank', title: response.statusText || 'Error', status: response.status };
}
//# sourceMappingURL=fetcher.js.map